// Initialize Mapbox
mapboxgl.accessToken = 'pk.eyJ1IjoibGVhZGlnaXRhbCIsImEiOiJjbWFtbjl1cmkwbHp4MmtzZHkzOHV0N3FkIn0.OIuZd5oZKl10DsqmQHO-kA';

// Parse countries data from data attribute
const parseCountriesData = () => {
    const countriesDataElement = document.getElementById('countries-data');
    if (!countriesDataElement) return {};
    
    const countriesDataString = countriesDataElement.textContent;
    return countriesDataString.split('##COUNTRY##').filter(Boolean).reduce((acc, countryData) => {
        const [country, coordsAndImage] = countryData.split('##COORDS##');
        if (country && coordsAndImage) {
            const [coords, imageAndRotate] = coordsAndImage.split('##IMAGE##');
            const [image, rotation] = imageAndRotate.split('##ROTATE##');
            
            // Split by comma and convert to numbers, handling potential spaces
            const [lon, lat] = coords.split(',').map(coord => parseFloat(coord.trim()));
            
            if (!isNaN(lon) && !isNaN(lat)) {
                acc[country] = {
                    coordinates: [lon, lat],
                    image: image,
                    rotation: parseFloat(rotation) || 0
                };
            } else {
                console.warn(`Invalid coordinates for ${country}:`, coords);
            }
        }
        return acc;
    }, {});
};

// Initialize map with basic style
const initializeMap = () => {
    const map = new mapboxgl.Map({
        container: 'map',
        style: {
            'version': 8,
            'sources': {
                'map-background': {
                    'type': 'image',
                    'url': 'https://cdn.shopify.com/s/files/1/0519/7519/2772/files/map.png?v=1747840322',
                    'coordinates': [
                        [-260, 85],
                        [260, 85],
                        [260, -85],
                        [-260, -85]
                    ]
                }
            },
            'layers': [
                {
                    'id': 'background',
                    'type': 'background',
                    'paint': {
                        'background-color': 'transparent'
                    }
                },
                {
                    'id': 'map-image',
                    'type': 'raster',
                    'source': 'map-background',
                    'paint': {
                        'raster-opacity': 1
                    }
                }
            ]
        },
        center: [0, 0],
        zoom: window.innerWidth <= 768 ? 0.05 : 0.08,
        minZoom: window.innerWidth <= 768 ? 0.05 : 0.08,
        maxZoom: window.innerWidth <= 768 ? 2 : 1.5,
        projection: 'mercator',
        interactive: true,
        attributionControl: false,
        renderWorldCopies: false,
        maxBounds: window.innerWidth <= 768 ? [
            [-260, -85],  // southwest coordinates
            [260, 85]     // northeast coordinates
        ] : [
            [-260, -85],  // southwest coordinates
            [260, 85]     // northeast coordinates
        ],
        scrollZoom: false
    });

    return map;
};

// Initialize the travel club functionality
const initializeTravelClub = () => {
    const countriesData = parseCountriesData();
    const map = initializeMap();
    const markers = {};

    // Fonction utilitaire pour gérer la classe active
    const updateActiveCountry = (countryName) => {
        // Retirer la classe active de tous les éléments
        document.querySelectorAll('.mm-travel-club-country-item').forEach(item => {
            item.classList.remove('mm-country-active');
        });
        
        // Ajouter la classe active à l'élément correspondant
        if (countryName) {
            const countryItem = document.querySelector(`.mm-travel-club-country-item[data-country="${countryName}"]`);
            if (countryItem) {
                countryItem.classList.add('mm-country-active');
            }
        }
    };

    // Add navigation controls
    const navControl = new mapboxgl.NavigationControl({
        showCompass: false,
        showZoom: true
    });
    map.addControl(navControl, 'top-right');

    // Ajuster la carte lors du redimensionnement de la fenêtre
    window.addEventListener('resize', () => {
        const isMobile = window.innerWidth <= 768;
        map.setZoom(isMobile ? 0.05 : 0.08);
        map.setMinZoom(isMobile ? 0.05 : 0.08);
        map.setMaxZoom(isMobile ? 2 : 1.5);
    });

    // Set initial zoom and center after map loads
    map.on('load', () => {
        // Add markers for each country
        Object.entries(countriesData).forEach(([country, data]) => {
            if (data.coordinates && data.coordinates.length === 2) {
                // Create marker element
                const markerEl = document.createElement('div');
                markerEl.className = 'country-marker';
                markerEl.style.zIndex = '1000';

                // Create image element
                const img = document.createElement('img');
                img.className = 'mm-marker-image';
                img.src = data.image;
                img.style.objectFit = 'cover';
                img.style.transform = `rotate(${data.rotation}deg)`;
                
                // Add hover effect
                markerEl.addEventListener('mouseenter', () => {
                    img.style.transform = `rotate(${data.rotation}deg) scale(1.05)`;
                });
                
                markerEl.addEventListener('mouseleave', () => {
                    img.style.transform = `rotate(${data.rotation}deg)`;
                });
                
                // Add error handling
                img.onerror = () => {
                    console.error(`Failed to load image for ${country}. Image URL:`, data.image);
                    // Fallback to a colored div with country name
                    img.style.display = 'none';
                    const fallback = document.createElement('div');
                    fallback.style.width = '100%';
                    fallback.style.height = '100%';
                    fallback.style.display = 'flex';
                    fallback.style.alignItems = 'center';
                    fallback.style.justifyContent = 'center';
                    fallback.style.color = '#333';
                    fallback.style.fontSize = '14px';
                    fallback.style.fontWeight = 'bold';
                    fallback.textContent = country;
                    markerEl.appendChild(fallback);
                };

                // Add image to marker
                markerEl.appendChild(img);

                try {
                    // Create and add the marker
                    const marker = new mapboxgl.Marker({
                        element: markerEl,
                        anchor: 'center'
                    })
                        .setLngLat(data.coordinates)
                        .addTo(map);

                    // Stocker le marqueur dans l'objet markers
                    markers[country] = marker;

                    // Fonction pour centrer la carte sur le pays
                    const centerOnCountry = () => {
                        map.flyTo({
                            center: data.coordinates,
                            zoom: 4,
                            duration: 1000
                        });

                        // Réorganiser les marqueurs
                        Object.entries(markers).forEach(([countryName, markerObj]) => {
                            if (countryName === country) {
                                // Retirer et réajouter le marqueur sélectionné pour le mettre au premier plan
                                markerObj.remove();
                                markerObj.addTo(map);
                            }
                        });
                    };

                    // Add click event to marker
                    markerEl.addEventListener('click', () => {
                        centerOnCountry();
                        updateActiveCountry(country);

                        // En version mobile, ouvrir le slider des articles
                        if (window.innerWidth <= 768) {
                            const countryItem = document.querySelector(`.mm-travel-club-country-item[data-country="${country}"]`);
                            if (countryItem) {
                                countryItem.click();
                            }
                        } else {
                            // Trouver et ouvrir le dropdown correspondant
                            const dropdowns = document.querySelectorAll('.mm-travel-club-dropdown');
                            
                            dropdowns.forEach(dropdown => {
                                // Sélectionner le texte du pays dans le premier div
                                const countryNameElement = dropdown.querySelector('.mm-flex.mm-gap-10.mm-align-baseline');
                                if (countryNameElement) {
                                    // Récupérer le premier nœud texte qui contient le nom du pays
                                    const countryName = countryNameElement.childNodes[0].textContent.trim();
                                    
                                    if (countryName === country) {
                                        
                                        // Fermer tous les autres dropdowns
                                        dropdowns.forEach(d => {
                                            if (d !== dropdown) {
                                                const collapsible = d.querySelector('.mm-travel-club-collapsible');
                                                const content = d.querySelector('.mm-travel-club-texte');
                                                if (collapsible) collapsible.classList.remove('mm-active');
                                                if (content) content.style.maxHeight = null;
                                            }
                                        });

                                        // Ouvrir le dropdown correspondant
                                        const collapsible = dropdown.querySelector('.mm-travel-club-collapsible');
                                        const content = dropdown.querySelector('.mm-travel-club-texte');
                                        
                                        if (collapsible && content) {
                                            collapsible.classList.add('mm-active');
                                            content.style.maxHeight = content.scrollHeight + 'px';
                                            
                                            // Faire défiler jusqu'au dropdown
                                            dropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        } else {
                                            console.error('Éléments manquants dans le dropdown:', { collapsible, content });
                                        }
                                    }
                                } else {
                                    console.error('Élément de nom de pays non trouvé dans le dropdown');
                                }
                            });
                        }
                    });

                    // Ajouter l'événement de clic sur le dropdown
                    const dropdowns = document.querySelectorAll('.mm-travel-club-dropdown');
                    dropdowns.forEach(dropdown => {
                        const countryNameElement = dropdown.querySelector('.mm-flex.mm-gap-10.mm-align-baseline');
                        if (countryNameElement) {
                            const countryName = countryNameElement.childNodes[0].textContent.trim();
                            if (countryName === country) {
                                const collapsible = dropdown.querySelector('.mm-travel-club-collapsible');
                                if (collapsible) {
                                    collapsible.addEventListener('click', (e) => {
                                        // Empêcher le comportement par défaut du dropdown
                                        e.stopPropagation();
                                        // Centrer la carte sur le pays
                                        centerOnCountry();
                                    });
                                }
                            }
                        }
                    });

                } catch (error) {
                    console.error('Error creating marker:', error);
                }
            }
        });

        // Gestionnaire pour les éléments du slider mobile
        const countryItems = document.querySelectorAll('.mm-travel-club-country-item');
        const articleGroups = document.querySelectorAll('.mm-travel-club-articles-group');
        const sliderMobile = document.querySelector('.mm-travel-club-articles-slider-mobile');
        
        countryItems.forEach(item => {
            item.addEventListener('click', () => {
                const countryName = item.dataset.country;
                updateActiveCountry(countryName);
                
                if (countryName === 'TOUS') {
                    // Si on clique sur TOUS, on ferme le slider s'il est ouvert
                    if (sliderMobile && sliderMobile.classList.contains('active')) {
                        sliderMobile.classList.remove('active');
                    }
                    // Réinitialiser la vue de la carte
                    map.flyTo({
                        center: [0, 0],
                        zoom: window.innerWidth <= 768 ? 0.05 : 0.08,
                        duration: 1000
                    });
                } else {
                    // Masquer tous les groupes d'articles
                    articleGroups.forEach(group => {
                        group.style.display = 'none';
                    });
                    
                    // Afficher les articles du pays sélectionné
                    const selectedGroup = document.querySelector(`.mm-travel-club-articles-group[data-country="${countryName}"]`);
                    
                    if (selectedGroup) {
                        selectedGroup.style.display = 'block';
                        
                        // Afficher le slider mobile avec animation
                        if (sliderMobile) {
                            console.log('Activation du slider mobile');
                            // S'assurer que le slider est visible avant d'ajouter la classe active
                            sliderMobile.style.display = 'block';
                            // Petit délai pour s'assurer que le display est appliqué
                            setTimeout(() => {
                                sliderMobile.classList.add('active');
                                console.log('Classe active ajoutée');
                            }, 10);
                        }
                        
                        // Initialiser ou réinitialiser Splide pour ce groupe
                        const splideElement = selectedGroup.querySelector('.splide');
                        if (splideElement) {
                            if (window.articlesSplide) {
                                window.articlesSplide.destroy();
                            }
                            
                            window.articlesSplide = new Splide(splideElement, {
                                type: 'slide',
                                perPage: 1,
                                perMove: 1,
                                gap: '1rem',
                                padding: { left: '16px', right: '16px' },
                                arrows: false,
                                pagination: false,
                                drag: true,
                                snap: true,
                                dragMinThreshold: 10,
                                dragAngleThreshold: 30,
                                flickPower: 500,
                                flickMaxPages: 1,
                                waitForTransition: true,
                                speed: 400,
                                easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                                focus: 'start',
                                trimSpace: false,
                                updateOnMove: true,
                                autoWidth: true,
                                fixedWidth: '280px',
                                breakpoints: {
                                    768: {
                                        perPage: 1,
                                        padding: { left: '16px', right: '16px' }
                                    }
                                }
                            }).mount();

                            // Mettre à jour la barre de progression
                            function updateProgress() {
                                const progress = (window.articlesSplide.index + 1) / window.articlesSplide.length;
                                selectedGroup.querySelector('.articles-progress-bar').style.width = `${progress * 100}%`;
                            }

                            // Ajouter les gestionnaires d'événements pour les boutons de progression
                            selectedGroup.querySelector('.articles-progress-prev').addEventListener('click', () => {
                                window.articlesSplide.go('<');
                                updateProgress();
                            });

                            selectedGroup.querySelector('.articles-progress-next').addEventListener('click', () => {
                                window.articlesSplide.go('>');
                                updateProgress();
                            });

                            // Écouter l'événement de déplacement de Splide pour mettre à jour la progression
                            window.articlesSplide.on('move', updateProgress);
                            updateProgress();
                        }
                    }
                    
                    // Trouver le marqueur correspondant et centrer la carte
                    if (markers[countryName]) {
                        map.flyTo({
                            center: countriesData[countryName].coordinates,
                            zoom: 4,
                            duration: 1000
                        });
                        
                        Object.entries(markers).forEach(([country, markerObj]) => {
                            if (country === countryName) {
                                markerObj.remove();
                                markerObj.addTo(map);
                            }
                        });
                    }
                }
            });
        });

        // Force a map resize after adding markers
        setTimeout(() => {
            map.resize();
        }, 1000);

        // Gérer la fermeture du slider mobile
        const closeSliderButton = document.querySelector('.mm-travel-club-close-slider');
        if (closeSliderButton) {
            closeSliderButton.addEventListener('click', () => {
                const sliderMobile = document.querySelector('.mm-travel-club-articles-slider-mobile');
                if (sliderMobile) {
                    sliderMobile.classList.remove('active');
                    updateActiveCountry(null); // Retirer la classe active
                }
            });
        }
    });

    // Initialize collapsible elements
    const collapsibleElements = document.querySelectorAll('.mm-travel-club-collapsible');

    // Fonction pour gérer l'accessibilité des dropdowns
    const updateDropdownAccessibility = () => {
        collapsibleElements.forEach(item => {
            const content = item.nextElementSibling;
            if (content && content.classList.contains('mm-travel-club-texte')) {
                const focusableElements = content.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
                
                if (item.classList.contains('mm-active')) {
                    // Permettre le focus sur les éléments du dropdown ouvert
                    focusableElements.forEach(element => {
                        element.removeAttribute('tabindex');
                    });
                } else {
                    // Empêcher le focus sur les éléments du dropdown fermé
                    focusableElements.forEach(element => {
                        element.setAttribute('tabindex', '-1');
                    });
                }
            }
        });
    };

    // Initialiser l'accessibilité au chargement
    updateDropdownAccessibility();

    if (collapsibleElements.length > 0) {
        let isActiveFound = false;
        collapsibleElements.forEach(item => {
            if (item.classList.contains('mm-active')) {
                isActiveFound = true;
                const content = item.nextElementSibling;
                if (content && content.classList.contains('mm-travel-club-texte')) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            }
        });
    }

    collapsibleElements.forEach((item) => {
        item.addEventListener('click', function () {
            const currentlyActive = this.classList.contains('mm-active');

            collapsibleElements.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('mm-active');
                    const otherContent = el.nextElementSibling;
                    if (otherContent && otherContent.classList.contains('mm-travel-club-texte')){
                        otherContent.style.maxHeight = null;
                        // Empêcher le focus sur les éléments du dropdown fermé
                        const focusableElements = otherContent.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
                        focusableElements.forEach(element => {
                            element.setAttribute('tabindex', '-1');
                        });
                    }
                }
            });

            this.classList.toggle('mm-active');
            const content = this.nextElementSibling;

            if (content && content.classList.contains('mm-travel-club-texte')) {
                if (this.classList.contains('mm-active')) { 
                    content.style.maxHeight = content.scrollHeight + 'px';
                    // Permettre le focus sur les éléments du dropdown ouvert
                    const focusableElements = content.querySelectorAll('[tabindex="-1"]');
                    focusableElements.forEach(element => {
                        element.removeAttribute('tabindex');
                    });
                } else { 
                    content.style.maxHeight = null;
                    // Empêcher le focus sur les éléments du dropdown fermé
                    const focusableElements = content.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
                    focusableElements.forEach(element => {
                        element.setAttribute('tabindex', '-1');
                    });
                }
            }
            
            // Mettre à jour l'accessibilité après le changement d'état
            updateDropdownAccessibility();
        });
    });
};

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeTravelClub);

// Modifier le gestionnaire de clic en dehors
document.addEventListener('click', (event) => {
    if (window.innerWidth <= 768) {
        const sliderMobile = document.querySelector('.mm-travel-club-articles-slider-mobile');
        
        if (sliderMobile && sliderMobile.classList.contains('active')) {
            if (!sliderMobile.contains(event.target)) {
                sliderMobile.classList.remove('active');
                updateActiveCountry(null); // Retirer la classe active
            }
        }
    }
});
